import React from 'react';
import logo from './logo.svg';
import './App.css';
import { VeltComments, VeltCommentsSidebar, VeltProvider } from '@veltdev/react';
import Main from './components/Main/Main';
import YourAuthenticationComponent from './components/YourAuthenticationComponent/YourAuthenticationComponent';

function App() {
  return (
    <VeltProvider apiKey='j3AwoBkuQMTEgeqrmPve'>
      <YourAuthenticationComponent />
      <Main />
      <VeltComments />
      <VeltCommentsSidebar />
    </VeltProvider>
  );
}

export default App;
